import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'

export const chars = [
	'0',
	'1',
	'2',
	'3',
	'4',
	'5',
	'6',
	'7',
	'8',
	'9',
	'A',
	'B',
	'C',
	'D',
	'E',
	'F',
	'G',
	'H',
	'I',
	'J',
	'K',
	'L',
	'M',
	'N',
	'O',
	'P',
	'Q',
	'R',
	'S',
	'T',
	'U',
	'V',
	'W',
	'X',
	'Y',
	'Z'
];

/**
 * 随机生成字符串
 * @param {number} len 字符串个数
 */
export const randomStr = (len = 16) => {
    let res = ''
    for (let i = 0; i < len; i++) {
      const id = Math.ceil(Math.random() * 35)
      res += chars[id]
    }
    return res
  }

// 公钥
export const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDO3sTLyjgcX3ncduN8sQQYLp9+s4rT9xjkgamTkTRemjWJebtBHiw2vQx6XZhIkcqCOFvgHiARqqqLMgeFr1ERfwlsedtdQ8TbOUtd5pOPUSCNlVhHT4hqC2KvUviY1jf5iMFFSoy5KR5L9lLexr5HlVq7oCOZR+g7crImV/XpUQIDAQAB
  -----END PUBLIC KEY-----`

/**
 * AES加密
 * @param {string} text 需要加密的字符串
 */
export const aesEncrypt = text => {
    const key = randomStr()
    const iv = randomStr()
    const parseKey = CryptoJS.enc.Utf8.parse(key)
    const parseIv = CryptoJS.enc.Utf8.parse(iv)

    let encrypted = null
    if (text) {
        encrypted = CryptoJS.AES.encrypt(text, parseKey, {
            iv: parseIv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }).toString()
    }

    return {
        encrypted,
        key,
        iv,
        parseKey,
        parseIv
    }
}

/**
 * AES解密
 * @param {string} text 加密的字符串
 * @param {*} parseKey
 * @param {*} parseIv
 * @param {*} replace 是否替换换行
 */
export const aesDecrypt = (text, parseKey, parseIv, replace = true) => {
    let replaceData = text
    if (replace) {
        // 由于返回的数据有换行,此处需要替换掉
        replaceData = replaceData.replace(/[\r\n]/g, '')
    }

    var decrypted = CryptoJS.AES.decrypt(replaceData, parseKey, {
      iv: parseIv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
}

/**
 * RSA加密
 * @param {string} data 被加密的数据
 * string = JSON.stringify({k: kVal, iv:ivVal})
 */
export const rsaEncrypt = data => {
    const encrypt = new JSEncrypt()

    encrypt.setPublicKey(PUBLIC_KEY)

    return encrypt.encrypt(data)
}
